module.exports = __webpack_public_path__ + "media/St 4-washer dryer-hint.11efe3f0.wav";